var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 643,
    viewBox: "0 0 643 643",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 643,
    height: 643,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_7887)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 643,
    height: 643,
    fill: "#008393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5 407.015C394.567 407.015 453.786 347.911 453.786 275.008C453.786 202.104 394.567 143 321.5 143C248.433 143 189.214 202.104 189.214 275.008C189.214 347.911 248.433 407.015 321.5 407.015ZM373.898 456.518H269.102C170.209 456.518 90 536.548 90 635.244C90 654.984 106.04 671 125.82 671H517.2C536.981 671.031 553 655.046 553 635.244C553 536.548 472.802 456.518 373.898 456.518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_7887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 643,
    height: 643,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholderIcon);
export default __webpack_public_path__ + "static/media/user-placeholder-icon.2e0c8cafb1f56b44d4dc0573e055261d.svg";
export { ForwardRef as ReactComponent };